// components/copilot/ThinkingBubble.jsx
import React, { useState, useEffect } from "react";

const LOADING_STEPS = [
  "Loading audit matrix...",
  "Computing brand mentions and URL inventory...",
  "Extracting structured data from each question...",
  "Resolving brand entities and sentiment...",
  "Building pre-computed analytics tables...",
  "Preparing MAD Pilot context...",
];

const THINKING_STEPS = [
  "MAD Pilot is thinking...",
];

export default function ThinkingBubble({ kind = "thinking" }) {
  const steps = kind === "loading" ? LOADING_STEPS : THINKING_STEPS;
  const [stepIdx, setStepIdx] = useState(0);

  useEffect(() => {
    if (steps.length <= 1) return;
    setStepIdx(0);
    const interval = setInterval(() => {
      setStepIdx((i) => (i < steps.length - 1 ? i + 1 : i));
    }, 2500);
    return () => clearInterval(interval);
  }, [kind, steps.length]);

  const label = steps[stepIdx] || steps[0];

  return (
    <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: 10 }}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start" }}>
        <div className={["copilot-bubble", "is-assistant"].join(" ")}>
          <div className="copilot-bubble-meta" style={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
            <div>
              <strong style={{ textTransform: "uppercase" }}>assistant</strong>
              <span> • {new Date().toLocaleString()}</span>
            </div>
          </div>

          <div
            style={{
              padding: "12px 16px",
              minHeight: 44,
              minWidth: 320,
              color: "#6b7280",
              fontSize: 14,
              opacity: 0.9,
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 10, fontWeight: 400 }}>
              <span>{label}</span>
              <span
                aria-hidden="true"
                style={{
                  width: 14,
                  height: 14,
                  borderRadius: 999,
                  border: "2px solid rgba(107,114,128,.35)",
                  borderTopColor: "rgba(107,114,128,1)",
                  animation: "copilotSpin 0.9s linear infinite",
                }}
              />
            </div>
            {kind === "loading" && steps.length > 1 && (
              <div style={{
                marginTop: 8, display: "flex", gap: 4,
              }}>
                {steps.map((_, i) => (
                  <div
                    key={i}
                    style={{
                      width: 24, height: 3, borderRadius: 2,
                      background: i <= stepIdx ? "#6366f1" : "#e5e7eb",
                      transition: "background 0.3s",
                    }}
                  />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
